import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=0f1707a5&scoped=true"
import script from "./StatusIcon.vue?vue&type=script&lang=js"
export * from "./StatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1707a5",
  null
  
)

export default component.exports